import React, { useMemo } from 'react';
// import { SharesMembersType, TabKeyType } from '../types'
// import { DepIcon, OrgIcn } from '../assets/icons/svg'
import styles from './index.module.less';
import { replaceUrlWithHost } from '../utils';
interface IProps {
  avatar: string;
  name: string;
  size?: number;
  Icon?: any;
}
export default function Avatar(props: IProps) {
  const { avatar = '', name = '', size = 32, Icon } = props;
  const text = name ? name.substring(0, 1) : '';
  const GetIcon = useMemo(() => {
    if (avatar) {
      return (
        <img
          width={size}
          height={size}
          className={styles['avatar-img']}
          src={replaceUrlWithHost(avatar)}
        />
      );
    } else if (Icon) {
      return (
        <div
          style={{
            color: '#fff',
            //   backgroundColor: '#306fdc',
            borderRadius: 8,
            height: size,
            width: size,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {Icon}
        </div>
      );
    } else {
      return <span className={styles['avatar-img']}>{text}</span>;
    }
  }, [avatar, size]);
  return <div style={{ display: 'flex' }}>{GetIcon}</div>;
}
